import type { ChallengePhaseWithCountDto } from '@@types/api.types';
import { Button } from '@components/ui/button';
import { cn } from '@lib/utils';
import React from 'react';

type IntelTechnologiesPhaseFiltersProps = {
  onPhaseFilterChange: (phaseId: string | null) => void;
  phases: ChallengePhaseWithCountDto[];
  selectedPhaseFilter: string | null;
};

export const IntelTechnologiesPhaseFilters: React.FC<IntelTechnologiesPhaseFiltersProps> = (props) => {
  const { onPhaseFilterChange, phases, selectedPhaseFilter } = props;

  const isAllSelected = !selectedPhaseFilter || selectedPhaseFilter === 'all';

  return (
    <div className="flex gap-2 overflow-x-auto pb-2">
      <Button
        className={cn('whitespace-nowrap', isAllSelected && 'bg-primary text-white')}
        onClick={() => onPhaseFilterChange(null)}
        size="sm"
        type="button"
        variant={isAllSelected ? 'primary' : 'secondary'}
      >
        All Technologies
      </Button>

      {phases.map((phase, index) => {
        const isSelected = selectedPhaseFilter === phase.id;
        return (
          <Button
            key={phase.id}
            className={cn('whitespace-nowrap', isSelected && 'bg-primary text-white')}
            onClick={() => onPhaseFilterChange(phase.id)}
            size="sm"
            type="button"
            variant={isSelected ? 'primary' : 'secondary'}
          >
            Phase {index + 1}: {phase.name}
          </Button>
        );
      })}
    </div>
  );
};
